import { render, staticRenderFns } from "./GalleryContents.vue?vue&type=template&id=2dbdb763&scoped=true&"
import script from "./GalleryContents.vue?vue&type=script&lang=js&"
export * from "./GalleryContents.vue?vue&type=script&lang=js&"
import style0 from "./GalleryContents.vue?vue&type=style&index=0&id=2dbdb763&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbdb763",
  null
  
)

export default component.exports